module.exports = __webpack_public_path__ + "static/media/2 (7).549d4e13.jpg";